import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PaymentDetail from '../Checkout/PaymentDetail';
import BankDraftForm from './BankDraftForm';
import useWindowDimensions from '../../common/useWindowDimensions';

// Credit card and bank draft only - the Digital Wallets (Google Pay / Apple Pay) option was
// removed for now; neither was wired to a payment API.
const PaymentMethodSelector = ({ activeKey, setActiveKey, submitOrderRef }) => {
  const { t } = useTranslation();
  const { isMobile } = useWindowDimensions();
  const [selectedMethod, setSelectedMethod] = useState('creditCard');

  const renderRadio = (value, labelKey) => (
    <label className="spc-payment-method-radio">
      <input
        type="radio"
        name="spc-payment-method"
        checked={selectedMethod === value}
        onChange={() => setSelectedMethod(value)}
      />
      <span>{t(labelKey)}</span>
    </label>
  );

  return (
    <div className="spc-payment-method-selector">
      <h4 className="spc-payment-method-selector__label">{t('singlePageCheckout.paymentMethodLabel')}</h4>

      <div className="spc-payment-method-radio-row">
        {renderRadio('creditCard', 'singlePageCheckout.paymentCreditCard')}
        {renderRadio('bankDraft', 'singlePageCheckout.paymentBankDraft')}
      </div>
      {isMobile && <div className="spc-payment-method-divider" />}

      {selectedMethod === 'creditCard' && (
        <PaymentDetail activeKey={activeKey} setActiveKey={setActiveKey} submitOrderRef={submitOrderRef} compactLayout />
      )}
      {selectedMethod === 'bankDraft' && (
        <BankDraftForm submitOrderRef={submitOrderRef} />
      )}
    </div>
  );
};

export default PaymentMethodSelector;
